module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/ultilities/claims/claims/claims.component.html
// module id = ./src/app/ultilities/claims/claims/claims.component.html
// module chunks = main